import type { GetCourseAssets200ContentItemAssetType } from './getCourseAssets200ContentItemAssetType';

/**
 * 강의 자료 요약 정보
 */
export type GetCourseAssets200ContentItem = {
  /** 자료 유형 */
  assetType: GetCourseAssets200ContentItemAssetType;
  /** 자료 다운로드 URL */
  downloadUrl: string;
  /** 원본 파일 이름 */
  fileName: string;
  /**
   * 파일 크기 (bytes)
   * @nullable
   */
  fileSize?: number | null;
  /** 자료 ID */
  id: number;
  /** 자료 제목 (파일명 기반으로 백엔드에서 항상 생성) */
  title: string;
  /** 업로드 시간 */
  uploadedAt: string;
};
